import React from 'react';
import './Pokerwatch_new.css';
import "../../css/react-table-custom.css";
import { apiService } from '../../common/apiCallService.js';
import { baseUrl } from '../../common/config.js';
let imgUrl = "/images/handReplay/";
import $ from 'jquery';
import Loading from '../Loading.js';
import { InputDatePicker } from 'mygame-components';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import Dialog from 'material-ui/Dialog';
import HandReplayer from '../HandReplayer/HandReplayer.js';
import ReplayHand from '../HandReplayer/ReplayHand.js';

import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';

class PokerWatchReplayer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            openHandRep:true,
            data:JSON.parse(localStorage.getItem('handleReplayerData')),
        }
    
    }

  render() {
    this.props.setHeaderTitle(this.state.title);
    console.log('data-->', this.state.data);
    console.log("this.props.pwReplayer", this.props.pwReplayer);
    let fullVersion = 0
    console.log("navigator.appVersion-----------------------")
    console.log(navigator.appVersion)
    if (navigator.appVersion.indexOf("Mac") >= 0) {
      if (navigator.appVersion.indexOf("Mobile") >= 0) {
        let osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
        fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2] + osVersion[3]);
        if (fullVersion > 12.10) {
          fullVersion = 13
        } else {
          fullVersion = 12
        }
      } else {
        let osVersion = /OS X (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
        // console.log("osVersion", osVersion)
        if (osVersion) {
          fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2]);
          if (fullVersion > 10.13) {
            fullVersion = 13
          } else {
            fullVersion = 12
          }
        } else {
          fullVersion = 12
        }
      }
    } else {
      fullVersion = 13;
    }
    
       return   <div>
            <div style={{
              top: 0,
              left: 0,
              zIndex: 20000, 
              width: "100%", 
              height: "100%",
              position: "fixed",
              backgroundColor : '#2c2c34'
            }}>
            {fullVersion && fullVersion < 13 ? 
             <HandReplayer 
                  replayerScreen={'fromPlayerDetails'}
                  loginStatus = {true} 
                  gameNo={this.state.data.gameNo} 
                  partitionDate={this.state.data.partitionDate}
                  accountName={this.state.data.playerName}
                  playerAlias={this.state.data.players_alias}
                  gameTypeForTitle={this.state.data.gameType} 
                  fromDate={ this.state.data.selectedFromDate}
                  toDate= {this.state.data.selectedToDate}
                  gameType={this.state.data.gameType} 
                  onClose={() => this.setState({ openHandRep: false })}
                  /> :
                  <ReplayHand 
                  replayerScreen={'fromPlayerDetails'}
                  loginStatus = {true} 
                  gameNo={this.state.data.gameNo} 
                  partitionDate={this.state.data.partitionDate}
                  accountName={this.state.data.playerName}
                  playerAlias={this.state.data.playerName}
                  gameTypeForTitle={this.state.data.gameType} 
                  fromDate={ this.state.data.selectedFromDate}
                  toDate= {this.state.data.selectedToDate}
                  gameType={this.state.data.gameType} 
                  onClose={() => this.setState({ openHandRep: false })}
                  />}
            </div>
            </div>
            
        }
}

const mapStateToProps = state => {
    console.log('statenew',state);
    return {
      pwReplayer: state.pwReplayer
    };
  };
  const mapDispatchToProps = dispatch => {
    return {
      setHeaderTitle: (newTitle) => dispatch(actions.setHeaderTitle(newTitle))
    }
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(PokerWatchReplayer);


/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchNew/PokerWatchReplayer.js
 **/